/* eslint-disable @typescript-eslint/no-explicit-any */
import { isBlank } from 'housecall-ui/dist/common/ObjectHelper';

import { googleRef } from './external-libs/googleMaps';
import { isPresent } from './isPresent';

const componentForm: Record<string, string> = {
  street_number: 'short_name', // street_number
  route: 'short_name', // street name
  locality: 'long_name', // city
  sublocality_level_1: 'long_name', // alternate city
  neighborhood: 'long_name', // alternate city
  administrative_area_level_1: 'short_name', // state
  country: 'short_name', // country
  postal_code: 'short_name', // postalCode
};

export const US_AND_CANADA = ['us', 'ca'];

export function parseGoogleAddress(selectedPlace?: google.maps.places.PlaceResult) {
  if (isBlank(selectedPlace)) {
    return;
  }

  const selectedSuggest: any = {};

  selectedPlace.address_components?.forEach((addressComponent: any) => {
    const addressType = addressComponent.types[0] as string;

    const addressFromComponent = componentForm[addressType];
    if (addressFromComponent) {
      selectedSuggest[addressType] = addressComponent[addressFromComponent];
    }
  });

  let streetName = '';
  if (isPresent(selectedSuggest.street_number)) {
    streetName = streetName.concat(selectedSuggest.street_number);
  }
  if (isPresent(selectedSuggest.route)) {
    streetName = streetName.concat(' ', selectedSuggest.route);
  }
  if (isBlank(selectedSuggest.locality)) {
    selectedPlace.address_components?.forEach((addressComponent: any) => {
      addressComponent.types.forEach((type: string) => {
        const componentFormValue = componentForm[type];
        if (type === 'sublocality_level_1' && componentFormValue) {
          selectedSuggest[type] = addressComponent[componentFormValue];
        }
        if (type === 'neighborhood' && componentFormValue) {
          selectedSuggest[type] = addressComponent[componentFormValue];
        }
      });
    });
  }

  const callbackObject = {
    street: streetName,
    city: selectedSuggest.locality || selectedSuggest.sublocality_level_1 || selectedSuggest.neighborhood,
    state: selectedSuggest.administrative_area_level_1,
    postal_code: selectedSuggest.postal_code,
    country: selectedSuggest.country,
    latitude: selectedPlace?.geometry?.location?.lat() || null,
    longitude: selectedPlace?.geometry?.location?.lng() || null,
    formatted_address: selectedPlace.formatted_address,
  };

  return callbackObject;
}

export function getPlaceDetails(placeID: any, fieldsWanted: any) {
  return new Promise((resolve) => {
    new googleRef.maps.places.PlacesService(document.getElementById('map') as HTMLDivElement).getDetails(
      { placeId: placeID, fields: fieldsWanted },
      (response) => {
        resolve(response);
      }
    );
  });
}
